module.exports = __webpack_public_path__ + "img/phonediag.430e5234.png";